/* eslint-disable no-tabs */
import { setCustomerSupportChat } from "action/utils/setCustomerSupportChat";
import { updatePreferredLanguageApi } from "api/account/updatePreferredLanguageApi";
import PAImage from "component/design-system/images/PAImage";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import qs from "query-string";
import { useDispatch, useSelector } from "react-redux";
import initLiveChat from "util/chat-widget/init-live-chat";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { isBusinessHP } from "util/helper/helper";
import PASentry from "util/pa-sentry";
import { isLoginPage } from "util/url/checkRouteInclude";
import { translateFilters } from "../../api/category/translateFilters";
import { getFilters } from "../../util/helper/getFilters";
import { getNextQuery } from "../../util/url/getNextQuery";
import { getOrderedQuery } from "../../util/url/getOrderedQuery";
import styles from "./SwitchLanguage.module.scss";

function SwitchLanguage(props) {
  const router = useRouter();
  const { asPath, pathname } = router;
  const { className = "", flagWidth, flagHeight } = props;
  const dispatch = useDispatch();
  const { businessCustomer } = useSelector((store: RootState) => store.authenticationState);

  function onclickHandler() {
    // use location.search bcz it does not have make, model, year, engine, postal present in query
    // router query cannot be used here bcz it will result in all the above parameter being present in url while switching language
    const query = qs.parse(location.search);
    const localeToUpdate = router.locale === "fr" ? "en" : "fr";
    const customerSupportChat = localeToUpdate === "fr" ? "FRESHDESK" : "PARTSAVATAR_CHAT";
    dispatch(setCustomerSupportChat(customerSupportChat));
    updatePreferredLanguageApi(localeToUpdate.toUpperCase());
    const apiBody = getFilters(query);
    translateFilters(apiBody, localeToUpdate).then(({ data }) => {
      const filters = query;
      // Remove keys which have null value
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          filters[key] = data[key];
        }
      });
      const orderedQuery = getOrderedQuery(filters);
      const nextQuery = getNextQuery(orderedQuery);
      const href = `${asPath.split("?")[0]}?${nextQuery}`;
      let rAsPath = `${asPath.split("?")[0]}`;
      if (location.search) {
        rAsPath += `?${orderedQuery}`;
      }
      // href is needed here, otherwise vehicle will be removed while changing language
      if (href.startsWith("/fr/fr") || rAsPath.startsWith("/fr/fr")) {
        router.replace(href.replace("/fr/fr", "/fr"), rAsPath.replace("/fr/fr", "/fr"), { locale: localeToUpdate });
        PASentry.logException(new Error("Found wrong french href"), null, { href, rAsPath, nextQuery });
      } else {
        if (!businessCustomer && !isBusinessHP(asPath) && !isLoginPage(pathname)) {
          initLiveChat(localeToUpdate);
        }
        router.replace(href, rAsPath, { locale: localeToUpdate });
      }
    });
  }

  if (props.isTextOnly) {
    return (
      <div onClick={onclickHandler} className={styles.lang_text}>
        {router.locale === "fr" ? "View English Version" : "La Version en français"}
      </div>
    );
  }

  const switchAltText = "Car parts available for purchase in both English and French languages";

  return (
    <div
      className={`${styles.language_change_icon} ${className} `}
      onClick={onclickHandler}
    >
      <PAImage
        src={getRelativeImagePath("/images/public/maple-leaf.webp")}
        alt={switchAltText}
        title={switchAltText}
        height={flagHeight || 30}
        width={flagWidth || 30}
        className={styles.flag_image}
      />
      <div className="icon-label">
        <span style={{ textDecoration: router.locale === "en" ? "underline" : "none", fontWeight: router.locale === "en" ? 600 : 400, textUnderlineOffset: 3 }} className="p-5">EN</span>
        |
        <span style={{ textDecoration: router.locale === "fr" ? "underline" : "none", fontWeight: router.locale === "fr" ? 600 : 400, textUnderlineOffset: 3 }} className="p-5">FR</span>
      </div>
    </div>
  );
}

export default SwitchLanguage;
